export function handleChange(event, parent) {
    const target = event.target;
    //const value = target.type === 'checkbox' ? target.checked : target.value;
    const value = target.value;
    const name = target.name;
    parent.setState({ [name]: value });
}

function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

export function checkNumber(temp) {
    if (temp.startsWith("0")) {
        temp = temp.slice(1, temp.length);
    }
    if (temp.startsWith("0")) {
        temp = temp.slice(1, temp.length);
    }
    if (!temp.startsWith("98"))
        temp = "98" + temp;
    return temp;
}

export function sendSms(phone, href) {
    phone=checkNumber(phone);
    const link = document.createElement('a');
    let charPhone = '?';
    const device = getMobileOperatingSystem();
    if (device == "iOS")
        charPhone = "&";

    link.href = `sms:${phone}${charPhone}body=${href}`;
    //link.setAttribute('download', 'file.pdf');
    document.body.appendChild(link);
    link.click();
}


export default {
    handleChange,
    sendSms,



}